import { render, staticRenderFns } from "./AnomalyColorbar.vue?vue&type=template&id=0097bb1c&scoped=true"
import script from "./AnomalyColorbar.vue?vue&type=script&lang=js"
export * from "./AnomalyColorbar.vue?vue&type=script&lang=js"
import style0 from "./AnomalyColorbar.vue?vue&type=style&index=0&id=0097bb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0097bb1c",
  null
  
)

export default component.exports